module.exports = __webpack_public_path__ + "static/img/technologyu02.694d88c9.png";